const gsapController = async function() {
    const counter = document.querySelector(".counter") !== null;

    if ( counter ) {
        let gsap = await (await import('gsap')).default;
        let ScrollTrigger = await (await import('gsap/ScrollTrigger')).default;
        let ScrollToPlugin = await (await import('gsap/ScrollToPlugin')).default;
        // let GSDevTools = await (await import('gsap/GSDevTools')).default;

        gsap.registerPlugin(ScrollTrigger)
        gsap.registerPlugin(ScrollToPlugin)
        // gsap.registerPlugin(GSDevTools)

        if ( window.location.hash ) {
            gsap.to(window, {duration: 1, scrollTo: {
                y: window.location.hash,
                offsetY: document.querySelector(".header") ? document.querySelector(".header").clientHeight : 50,
            }});
        }

        if ( counter ) {
            let AnimatedSection = await (await import('./gsap/counter-anim')).default;
            AnimatedSection(gsap, ScrollTrigger);
        }
    }
}

export const init = gsapController;